export default "__VITE_ASSET__ON7NSEYa__"